import { Component, OnInit, ViewChild } from '@angular/core';
import { BudgetCategoryService } from '../../../services/budget-category.service';
import { BudgetSubcategoryService } from '../../../services/budget-subcategory.service';
import { ToastService } from '../../../services/toast.service';
import { LoadingService } from '../../../services/loading.service';
import { AuthorizationService } from '../../../services/authorization.service';
import { forkJoin } from 'rxjs';
import { NewSubcategoryComponent } from './new-subcategory/new-subcategory.component';


@Component({
  selector: 'app-config-budgets',
  templateUrl: './config-budgets.component.html',
  styleUrl: './config-budgets.component.scss'
})
export class ConfigBudgetsComponent implements OnInit {
  @ViewChild(NewSubcategoryComponent) newSubcategoryComponent!: NewSubcategoryComponent;
  
  public categories :any;
  public subcategories :any;
  categoryId : number | null = null;
  subCategoryId : number | null = null;
  modalOpen = false;
  newCategoryModal = false;
  newSubcategoryModal = false;
  
  // Modo de solo lectura para los modales
  categoryReadonly = false;
  subcategoryReadonly = false;

  constructor(
    private _budgetCategoryService : BudgetCategoryService,
    private _budgetSubcategoryService : BudgetSubcategoryService,
    private toastService: ToastService,
    private _loadingService : LoadingService,
    public authService: AuthorizationService
  )
  {

  }
  
  // Verificar permisos
  get canCreate(): boolean {
    return this.authService.hasPermission('CONFIG_BUDGETS_CREATE');
  }
  
  get canUpdate(): boolean {
    return this.authService.hasPermission('CONFIG_BUDGETS_UPDATE');
  }
  
  get canManageSubcategory(): boolean {
    return this.authService.hasPermission('CONFIG_BUDGETS_SUBCATEGORY');
  }

  ngOnInit(): void {
    this.loadData();
  }

  loadData() {
    this._loadingService.show();
    forkJoin({
      categories: this._budgetCategoryService.getAll(),
      subcategories: this._budgetSubcategoryService.getAll(),
    }).subscribe({
      next: (results) => {
        this.categories = results.categories.data;
        this.subcategories = results.subcategories.data;
        this._loadingService.hide();
      },
      error: (error) => {
        console.error('Error loading data', error);
        this._loadingService.hide();
      }      
    });
  }
  

  newCategoryName = '';
  newSubcategoryName = '';
  selectedCategoryIndex = -1;

  toggleCategory(index: number) {
    this.categories[index].expanded = !this.categories[index].expanded;
  }

  addCategory():void {
    this.categoryId = null; // Asegurar que está en modo creación
    this.categoryReadonly = false;
    this.newCategoryModal = true;
  }

  addSubcategory():void {
    this.subCategoryId = null; // Asegurar que está en modo creación
    this.subcategoryReadonly = false;
    this.newSubcategoryModal = true;
    this.loadSubcategoryData();
  }

  closeCategoryModal():void {
    this.newCategoryModal = false;
    this.categoryId = null;
    this.categoryReadonly = false;
  }

  closeSubCategoryModal():void {
    this.newSubcategoryModal = false;
    this.subCategoryId = null;
    this.subcategoryReadonly = false;
  }

  // Ver categoría en modo solo lectura
  viewCategory(category: any): void {
    this.categoryId = category.id;
    this.categoryReadonly = true;
    this.newCategoryModal = true;
  }

  // Editar categoría (requiere permiso)
  editCategory(category: any): void {
    this.categoryId = category.id;
    this.categoryReadonly = false;
    this.newCategoryModal = true;
  }

  // Ver subcategoría en modo solo lectura
  viewSubcategory(subcategory: any): void {
    this.subcategoryReadonly = true;
    this.newSubcategoryModal = true;
    setTimeout(() => {
      this.subCategoryId = subcategory.id;
    }, 0);
  }

  // Editar subcategoría (requiere permiso)
  editSubcategory(subcategory: any): void {
    this.subcategoryReadonly = false;
    this.newSubcategoryModal = true;
    setTimeout(() => {
      this.subCategoryId = subcategory.id;
    }, 0);
  }

  onRetrieveData(): void {
    this.loadData(); // Recarga las categorías cuando se recibe el evento
  }

  loadSubcategoryData(): void {
    setTimeout(() => {
      if (this.newSubcategoryComponent) {
        this.newSubcategoryComponent.loadDataOnOpen();
      }
    });
  }

}
